export function hash (value) {
  if (value === null) {
    return ''
  }
  return String(value).split('').reduce(function (a, b) {
    a = ((a << 5) - a) + b.charCodeAt(0)
    return a & a
  }, 0)
}
